
require('./bootstrap')


import { animate, timeline, stagger } from "motion"

const cm3glasses = document.querySelectorAll(".cm3-glass")
const cm3PosIndicator = document.getElementById("cm3-pos-indicator")

const cm3Sunglasses = document.querySelectorAll(".cm3sun-glass")
const cm3SunPosIndicator = document.getElementById("cm3sun-pos-indicator")

const totalDuration = 5
const delay = 0
const stepIndicatorMinScale = 0.15

const cm3colors = {
    smokeygrey : ["#f3f4f5", null, "#b3b9be", null, "#5c666d", null],
    chestnutbrown : ["#d6c8bf", null, "#ae8e7c", null, "#784a34", null],
    pilotgreen : ["#d5dbdb", null, "#7c8c8b", null, "#536966", null],
    steelblue : ["#d2d5dc", null, "#788395", null, "#4d657d", null],    
}

const cm3Suncolors = {
    smokeygrey : ["#a6adb3", null, "#5c666d", null],
    chestnutbrown : ["#ae8e7c", null, "#784a34", null],
    fashiongreen : ["#b6c9c5", null, "#4f6f6e", null],
    contrastorange : ["#e39d21", null, "#6d4b22", null],
}

const animationOptions = { 
    duration: totalDuration,
    repeat: Infinity,
    direction: "alternate",
    easing: 'linear',
    delay: delay,
}

let cm3Shades = (color) => {
    return timeline(
        [
            [
                cm3glasses,
                { fill: cm3colors[color] },
                { 
                    duration: totalDuration,
                }
            ],
            [
                cm3PosIndicator,
                { 
                    left: ["calc(16.667% - 44px)", null, "calc(50% - 44px)", null, "calc(83.333% - 44px)", null],
                }, 
                { 
                    at: "<", 
                    duration: totalDuration, 
                }
            ],
            [
                cm3PosIndicator,
                { 
                    scale: [1],
                }, 
                { 
                    at: "<", 
                }
            ],
            [
                cm3PosIndicator,
                { 
                    scale: [stepIndicatorMinScale],
                }, 
                { 
                    at: 0.683333333333333, 
                    duration: 0.15
                }
            ],
            [
                cm3PosIndicator,
                { 
                    scale: [1],
                }, 
                { 
                    at: 2, 
                    duration: 0.15
                }
            ],
            [
                cm3PosIndicator,
                { 
                    scale: [stepIndicatorMinScale],
                }, 
                { 
                    at: 2.5, 
                    duration: 0.15
                }
            ],
            [
                cm3PosIndicator,
                { 
                    scale: [1],
                }, 
                { 
                    at: 4.166666666666667, 
                    duration: 0.15
                }
            ],
    
        ],
        animationOptions
    )
}

let cm3ShadesAnimation = cm3Shades('smokeygrey') 
    
document.querySelectorAll(".cm3-color-picker").forEach(picker => { 
    picker.addEventListener("click", (el) => {

        document.getElementById('cm3-active-color').style.transform = 'translateX(' + 100 * el.target.dataset.pos + '%)'
        document.querySelector('#cm3-color-name > span').innerHTML = el.target.dataset.name

        let currentTime = cm3ShadesAnimation.currentTime
        cm3ShadesAnimation.stop()
        cm3ShadesAnimation = cm3Shades(el.target.dataset.color)
        cm3ShadesAnimation.currentTime = currentTime
        cm3ShadesAnimation.play()
    })
});

let cm3SunShades = (color) => {
    return timeline(
        [
            [
                cm3Sunglasses,
                { fill: cm3Suncolors[color] },
                { 
                    duration: totalDuration,
                }
            ],
            [
                cm3SunPosIndicator,
                { 
                    left: ["calc(25% - 44px)", null, "calc(75% - 44px)", null],
                }, 
                { 
                    at: "<", 
                    duration: totalDuration, 
                }
            ],
            [
                cm3SunPosIndicator,
                { 
                    scale: [1],
                }, 
                { 
                    at: "<", 
                }
            ],
            [
                cm3SunPosIndicator,
                { 
                    scale: [stepIndicatorMinScale],
                }, 
                { 
                    at: 1.25, 
                    duration: 0.15
                }
            ],
            [
                cm3SunPosIndicator,
                { 
                    scale: [1],
                }, 
                { 
                    at: 3.5, 
                    duration: 0.15
                }
            ],
    
        ],
        animationOptions
    )
}

let cm3SunShadesAnimation = cm3SunShades('smokeygrey') 

document.querySelectorAll(".cm3sun-color-picker").forEach(picker => { 
    picker.addEventListener("click", (el) => {

        document.getElementById('cm3sun-active-color').style.transform = 'translateX(' + 100 * el.target.dataset.pos + '%)'
        document.querySelector('#cm3sun-color-name > span').innerHTML = el.target.dataset.name

        let currentTime = cm3SunShadesAnimation.currentTime
        cm3SunShadesAnimation.stop()
        cm3SunShadesAnimation = cm3SunShades(el.target.dataset.color)
        cm3SunShadesAnimation.currentTime = currentTime
        cm3SunShadesAnimation.play()
    })
});